module.exports = "<div class=\"wrapper\">\n  <div class=\"sidebar\" data-color='red' data-image=\"\">\n    <app-sidebar></app-sidebar>\n    <div class=\"sidebar-background\" style=\"background-image: url(../assets/img/sidebar.jpg)\"></div>\n  </div>\n  <div class=\"main-panel\">\n    <app-navbar></app-navbar>\n    <router-outlet></router-outlet>\n    <div *ngIf=\"isMaps('maps')\">\n      <app-footer></app-footer>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /app/SPA/src/app/client/client.component.html
// module id = ../../../../../src/app/client/client.component.html
// module chunks = 0